export default __webpack_public_path__ + "static/media/Haywood.3112d361.png";